if (!customElements.get('discount-metaobject-countdown')) {
    class DiscountMetaobjectCountdown extends HTMLElement {
        activeStart = new Date()
        activeEnd
        countDownTime = new Date()
        dates_restriction = []
        restriction_type;
        startTime = {
            hour: 0,
            minute: 0,
            second: 0
        }
        endTime = {
            hour: 23,
            minute: 59,
            second: 59
        }
        canShowCountDown = false;

        htmlDays; htmlHours; htmlMinutes; htmlSeconds
        timerInterval
        constructor() {
            super();
            this.initData();
            this.initElement();

            ///this.activeEnd = new Date(Date.now() + (5 * 1000));//test

            this.checkDiscountIsValid();
            //console.log("DiscountMetaobjectData", this.checkDiscountIsValid());
        }

        connectedCallback() {
            if (this.canShowCountDown) {
                this.timerInterval = setInterval(this.updateCountdown.bind(this), 1000)
            }
        }
        disconnectedCallback() {
            if (this.timerInterval) {
                clearTimeout(this.timerInterval)
            }
        }

        getNumberString(number) {
            if (number <= 9) {
                return "0" + number
            }
            return number
        }
        stopCountdown() {
            if (this.timerInterval) {
                clearTimeout(this.timerInterval)
            }
            var productManager = document.getElementById("product-page-content")
            // //console.log(productManager.fetchPrice);
            if (productManager) {
                productManager.fetchPrice(true)
            }
            this.remove()
        }
        updateCountdown() {
            var timeDiff = this.activeEnd.getTime() - Date.now();
            var day = Math.floor(timeDiff / (24 * 60 * 60 * 1000));
            var hour = Math.floor(timeDiff / (60 * 60 * 1000));
            var minutes = Math.floor(timeDiff % (60 * 60 * 1000) / 60 / 1000);
            var seconds = Math.floor(timeDiff % (60 * 1000) / 1000);
            // //console.log("DiscountMetaobjectData ", day, hour, minutes, seconds);

            // this.htmlDays.innerHTML = day;
            this.htmlHours.innerHTML = this.getNumberString(hour);
            this.htmlMinutes.innerHTML = this.getNumberString(minutes);
            this.htmlSeconds.innerHTML = this.getNumberString(seconds);
            if (timeDiff <= 0) {
                this.stopCountdown();
            }
        }

        initElement() {
            //console.log(this.canShowCountDown);
            if (this.canShowCountDown) {
                var container = this.getElementsByClassName("countdown-container").item(0)
                if (container) container.style = ""
                this.htmlHours = this.getElementsByClassName("countdown-hours").item(0)
                this.htmlMinutes = this.getElementsByClassName("countdown-minutes").item(0)
                this.htmlSeconds = this.getElementsByClassName("countdown-seconds").item(0)
            } else {
                this.remove()
            }
            // this.htmlDays = this.getElementsByClassName("countdown-days").item(0);

        }
        initData() {
            //console.log("DiscountMetaobjectData", this.dataset);
            this.activeStart = new Date(this.dataset.activeStart);

            if (this.dataset.start_time) {
                var startTimeData = this.dataset.start_time.split(":");
                this.startTime = {
                    hour: Number(startTimeData[0]),
                    minute: Number(startTimeData[1])
                }
                var start_timeMiliseconds = this.startTime.hour * 60 * 60 * 1000 + this.startTime.minute * 1000;
                this.activeStart.setTime(this.activeStart.getTime() + start_timeMiliseconds);
                // activeStart activeStart.getTime() + (start_timeMiliseconds)
            }
            if (this.dataset.activeEnd) {
                this.activeEnd = new Date(this.dataset.activeEnd);
                if (this.dataset.end_time) {
                    var endTimeData = this.dataset.end_time.split(":");
                    this.endTime.hour = Number(endTimeData[0]);
                    this.endTime.minute = Number(endTimeData[1])
                }
                this.activeEnd.setHours(this.endTime.hour)
                this.activeEnd.setMinutes(this.endTime.minute)
                this.activeEnd.setSeconds(this.endTime.second)

                this.canShowCountDown = true;
            }

            this.restriction_type = this.dataset.restriction_type;
            try {
                this.dates_restriction = JSON.parse(this.dataset.dates_restriction)
            } catch (error) {
            }

            //console.log("DiscountMetaobjectData", "startTime", this.activeStart);
            //console.log("DiscountMetaobjectData", "endTime", this.activeEnd);
            //console.log("DiscountMetaobjectData", "dates_restriction", this.dates_restriction);
            //console.log("DiscountMetaobjectData", "restriction_type", this.restriction_type);

        }
        checkDiscountIsValid() {
            if (this.dataset.enabled == "false") {
                return false;
            }
            var now = Date.now();
            var isValid = false

            if (now - this.activeStart.getTime() > 0) {

                if (this.activeEnd) {
                    isValid = this.activeEnd.getTime() - now > 0
                } else {
                    isValid = true;
                }
            }
            if (isValid) {
                if (this.restriction_type == "weekdays") {
                    var currentDay = new Date().getDay();//day of week
                    return this.dates_restriction.includes(currentDay);
                } else if (this.restriction_type == "monthDates") {
                    var currentDate = new Date().getDate();//day of month
                    return this.dates_restriction.includes(currentDate);
                } else {
                    return true;
                }
            }
            return true;
        }
    }
    customElements.define(
        'discount-metaobject-countdown',
        DiscountMetaobjectCountdown
    );
}